var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1364 6.3638H2.94863L5.79252 9.2077C6.1298 9.54492 6.1298 10.0918 5.79252 10.429C5.62388 10.5976 5.40285 10.682 5.18182 10.682C4.96078 10.682 4.73975 10.5976 4.57117 10.429L0.252987 6.11081C-0.0842915 5.77359 -0.0842915 5.22674 0.252987 4.88946L4.57117 0.571275C4.90839 0.234054 5.45524 0.234054 5.79252 0.571275C6.1298 0.908496 6.1298 1.45535 5.79252 1.79263L2.94863 4.63653H18.1364C18.6133 4.63653 19 5.02321 19 5.50016C19 5.97712 18.6133 6.3638 18.1364 6.3638Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrowLeft);
export default __webpack_public_path__ + "static/media/menu-arrow-left.14bd467c305064fcb498cf31235ade84.svg";
export { ForwardRef as ReactComponent };